import { render } from "./BlocksHistoryRow.vue?vue&type=template&id=93bfa844&scoped=true"
import script from "./BlocksHistoryRow.vue?vue&type=script&lang=js"
export * from "./BlocksHistoryRow.vue?vue&type=script&lang=js"

import "./BlocksHistoryRow.vue?vue&type=style&index=0&id=93bfa844&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-93bfa844"

export default script